import { ALEO_REQUEST_HASH, PALEO_TOKEN_ID, TOKEN_REGISTRY, USDC_REQUEST_HASH, USDT_REQUEST_HASH, VUSDC_TOKEN_ID, VUSDT_TOKEN_ID, WALEO_TOKEN_ID } from '@/configs/env';
import { TokenDetail } from '@/interfaces/token.interface';
import { ValueOf } from 'type-fest';

export const ZERO_REQUEST_HASH = '0u128';
export const NETWORK_TYPES = {
  MAINNET: 'mainnet',
  TESTNET: 'testnet'
} as const;

export const MARKET_TOKENS = {
  pALEO: 'pALEO',
  vUSDC: 'vUSDC',
  vUSDT: 'vUSDT',
  wALEO: 'wALEO',
  // USDCx: 'USDCx',
  // vUSDC1: 'vUSDC1',
  // vUSDC2: 'vUSDC2',
  // vUSDC3: 'vUSDC3',
  // vUSDC4: 'vUSDC4',
  // vUSDC5: 'vUSDC5',
  // vUSDC6: 'vUSDC6',
  // vUSDC7: 'vUSDC7',
  // vUSDC8: 'vUSDC8',
} as const;

export type tSupportedTokens = ValueOf<typeof MARKET_TOKENS>;
export type tNetworkTypes = ValueOf<typeof NETWORK_TYPES>;

export type TokenDetails = Record<tSupportedTokens, TokenDetail>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TokenRecords = Record<tSupportedTokens, Record<string, any>[]>;

export const TOKEN_DETAILS: TokenDetails = {
  [MARKET_TOKENS.pALEO]: {
    key: MARKET_TOKENS.pALEO,
    name: 'pALEO',
    symbol: 'pALEO',
    tokenProgram: TOKEN_REGISTRY,
    decimals: 6,
    isActive: true,
    tokenId: {
      [NETWORK_TYPES.MAINNET]: PALEO_TOKEN_ID,
      [NETWORK_TYPES.TESTNET]: PALEO_TOKEN_ID
    },
    requestHash: ALEO_REQUEST_HASH,
    balanceMap: 'authorized_balances',
    logo: '/images/aleo-tokens/pALEO.svg',
    tokenInfo: {
      maxLTV: 60 / 100,
      liquidationBonus: 10 / 100,
      liquidationThreshold: 75 / 100,
      optimalUtilizationRate: 70 / 100,
      baseRate: 0 / 100,
      slopeRate1: 0.4,
      slopeRate2: 4,
    }
  },
  [MARKET_TOKENS.vUSDC]: {
    key: MARKET_TOKENS.vUSDC,
    name: 'vUSDC',
    symbol: 'vUSDC',
    tokenProgram: 'token_registry.aleo',
    decimals: 6,
    isActive: true,
    tokenId: {
      [NETWORK_TYPES.MAINNET]: VUSDC_TOKEN_ID,
      [NETWORK_TYPES.TESTNET]: VUSDC_TOKEN_ID
    },
    requestHash: USDC_REQUEST_HASH,
    balanceMap: 'authorized_balances',
    logo: '/images/aleo-tokens/vUSDC.svg',
    tokenInfo: {
      maxLTV: 60 / 100,
      liquidationBonus: 10 / 100,
      liquidationThreshold: 75 / 100,
      optimalUtilizationRate: 70 / 100,
      baseRate: 0 / 100,
      slopeRate1: 0.4,
      slopeRate2: 4,
    }
  },
  [MARKET_TOKENS.vUSDT]: {
    key: MARKET_TOKENS.vUSDT,
    name: 'vUSDT',
    symbol: 'vUSDT',
    tokenProgram: 'token_registry.aleo',
    decimals: 6,
    isActive: true,
    tokenId: {
      [NETWORK_TYPES.MAINNET]: VUSDT_TOKEN_ID,
      [NETWORK_TYPES.TESTNET]: VUSDT_TOKEN_ID
    },
    requestHash: USDT_REQUEST_HASH,
    balanceMap: 'authorized_balances',
    logo: '/images/aleo-tokens/vUSDT.svg',
    tokenInfo: {
      maxLTV: 60 / 100,
      liquidationBonus: 10 / 100,
      liquidationThreshold: 75 / 100,
      optimalUtilizationRate: 70 / 100,
      baseRate: 0 / 100,
      slopeRate1: 0.4,
      slopeRate2: 4,
    }
  },
  [MARKET_TOKENS.wALEO]: {
    key: MARKET_TOKENS.wALEO,
    name: 'wALEO',
    symbol: 'wALEO',
    tokenProgram: 'token_registry.aleo',
    decimals: 6,
    isActive: true,
    tokenId: {
      [NETWORK_TYPES.MAINNET]: WALEO_TOKEN_ID,
      [NETWORK_TYPES.TESTNET]: WALEO_TOKEN_ID
    },
    requestHash: ZERO_REQUEST_HASH,
    balanceMap: 'authorized_balances',
    logo: '/images/aleo-tokens/pALEO.svg',
    tokenInfo: {
      maxLTV: 60 / 100,
      liquidationBonus: 10 / 100,
      liquidationThreshold: 75 / 100,
      optimalUtilizationRate: 70 / 100,
      baseRate: 0 / 100,
      slopeRate1: 0.4,
      slopeRate2: 4,
    }
  },
  // [MARKET_TOKENS.USDCx]: {
  //   key: MARKET_TOKENS.USDCx,
  //   name: 'USDCx',
  //   symbol: 'USDCx',
  //   tokenProgram: 'balances.aleo',
  //   decimals: 6,
  //   isActive: true,
  //   tokenId: {
  //     [NETWORK_TYPES.MAINNET]: USDCX_TOKEN_ID,
  //     [NETWORK_TYPES.TESTNET]: USDCX_TOKEN_ID
  //   },
  //   requestHash: ZERO_REQUEST_HASH,
  //   balanceMap: 'authorized_balances',
  //   logo: '/images/vUSDC.png',
  //   tokenInfo: {
  //     maxLTV: 60 / 100,
  //     liquidationBonus: 10 / 100,
  //     liquidationThreshold: 75 / 100,
  //     optimalUtilizationRate: 70 / 100,
  //     baseRate: 0 / 100,
  //     slopeRate1: 0.4,
  //     slopeRate2: 4,
  //   }
  // }
  // [MARKET_TOKENS.vUSDC2]: {
  //   key: MARKET_TOKENS.vUSDC2,
  //   name: 'vUSDC2',
  //   symbol: 'vUSDC2',
  //   tokenProgram: 'token_registry.aleo',
  //   decimals: 6,
  //   isActive: true,
  //   tokenId: {
  //     [NETWORK_TYPES.MAINNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722039field',
  //     [NETWORK_TYPES.TESTNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722039field'
  //   },
  //   balanceMap: 'authorized_balances',
  //   logo: '/images/vUSDC.png',
  //   tokenInfo: {
  //     maxLTV: 60/100,
  //     liquidationBonus: 10/100,
  //     liquidationThreshold: 75/100,
  //     optimalUtilizationRate: 70/100,
  //     baseRate: 0/100,
  //     slopeRate1: 0.4,
  //     slopeRate2: 4,

  //   }
  // },
  // [MARKET_TOKENS.vUSDC3]: {
  //   key: MARKET_TOKENS.vUSDC3,
  //   name: 'vUSDC3',
  //   symbol: 'vUSDC3',
  //   tokenProgram: 'token_registry.aleo',
  //   decimals: 6,
  //   isActive: true,
  //   tokenId: {
  //     [NETWORK_TYPES.MAINNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722041field',
  //     [NETWORK_TYPES.TESTNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722041field'
  //   },
  //   balanceMap: 'authorized_balances',
  //   logo: '/images/vUSDC.png',
  //   tokenInfo: {
  //     maxLTV: 60/100,
  //     liquidationBonus: 10/100,
  //     liquidationThreshold: 75/100,
  //     optimalUtilizationRate: 70/100,
  //     baseRate: 0/100,
  //     slopeRate1: 0.4,
  //     slopeRate2: 4,

  //   }
  // },
  // [MARKET_TOKENS.vUSDC4]: {
  //   key: MARKET_TOKENS.vUSDC4,
  //   name: 'vUSDC4',
  //   symbol: 'vUSDC4',
  //   tokenProgram: 'token_registry.aleo',
  //   decimals: 6,
  //   isActive: true,
  //   tokenId: {
  //     [NETWORK_TYPES.MAINNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722043field',
  //     [NETWORK_TYPES.TESTNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722043field'
  //   },
  //   balanceMap: 'authorized_balances',
  //   logo: '/images/vUSDC.png',
  //   tokenInfo: {
  //     maxLTV: 60/100,
  //     liquidationBonus: 10/100,
  //     liquidationThreshold: 75/100,
  //     optimalUtilizationRate: 70/100,
  //     baseRate: 0/100,
  //     slopeRate1: 0.4,
  //     slopeRate2: 4,
  //   }
  // },
  // [MARKET_TOKENS.vUSDC5]: {
  //   key: MARKET_TOKENS.vUSDC5,
  //   name: 'vUSDC5',
  //   symbol: 'vUSDC5',
  //   tokenProgram: 'token_registry.aleo',
  //   decimals: 6,
  //   isActive: true,
  //   tokenId: {
  //     [NETWORK_TYPES.MAINNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722044field',
  //     [NETWORK_TYPES.TESTNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722044field'
  //   },
  //   balanceMap: 'authorized_balances',
  //   logo: '/images/vUSDC.png',
  //   tokenInfo: {
  //     maxLTV: 60/100,
  //     liquidationBonus: 10/100,
  //     liquidationThreshold: 75/100,
  //     optimalUtilizationRate: 70/100,
  //     baseRate: 0/100,
  //     slopeRate1: 0.4,
  //     slopeRate2: 4,

  //   }
  // },
  // [MARKET_TOKENS.vUSDC6]: {
  //   key: MARKET_TOKENS.vUSDC6,
  //   name: 'vUSDC6',
  //   symbol: 'vUSDC6',
  //   tokenProgram: 'token_registry.aleo',
  //   decimals: 6,
  //   isActive: true,
  //   tokenId: {
  //     [NETWORK_TYPES.MAINNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722045field',
  //     [NETWORK_TYPES.TESTNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722045field'
  //   },
  //   balanceMap: 'authorized_balances',
  //   logo: '/images/vUSDC.png',
  //   tokenInfo: {
  //     maxLTV: 60/100,
  //     liquidationBonus: 10/100,
  //     liquidationThreshold: 75/100,
  //     optimalUtilizationRate: 70/100,
  //     baseRate: 0/100,
  //     slopeRate1: 0.4,
  //     slopeRate2: 4,

  //   }
  // },
  // [MARKET_TOKENS.vUSDC7]: {
  //   key: MARKET_TOKENS.vUSDC7,
  //   name: 'vUSDC7',
  //   symbol: 'vUSDC7',
  //   tokenProgram: 'token_registry.aleo',
  //   decimals: 6,
  //   isActive: true,
  //   tokenId: {
  //     [NETWORK_TYPES.MAINNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722049field',
  //     [NETWORK_TYPES.TESTNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722049field'
  //   },
  //   balanceMap: 'authorized_balances',
  //   logo: '/images/vUSDC.png',
  //   tokenInfo: {
  //     maxLTV: 60/100,
  //     liquidationBonus: 10/100,
  //     liquidationThreshold: 75/100,
  //     optimalUtilizationRate: 70/100,
  //     baseRate: 0/100,
  //     slopeRate1: 0.4,
  //     slopeRate2: 4,

  //   }
  // },
  // [MARKET_TOKENS.vUSDC8]: {
  //   key: MARKET_TOKENS.vUSDC8,
  //   name: 'vUSDC8',
  //   symbol: 'vUSDC8',
  //   tokenProgram: 'token_registry.aleo',
  //   decimals: 6,
  //   isActive: true,
  //   tokenId: {
  //     [NETWORK_TYPES.MAINNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722047field',
  //     [NETWORK_TYPES.TESTNET]: '1068104870852223474792716721054209526718172707571751136410402215071671722047field'
  //   },
  //   balanceMap: 'authorized_balances',
  //   logo: '/images/vUSDC.png',
  //   tokenInfo: {
  //     maxLTV: 60/100,
  //     liquidationBonus: 10/100,
  //     liquidationThreshold: 75/100,
  //     optimalUtilizationRate: 70/100,
  //     baseRate: 0/100,
  //     slopeRate1: 0.4,
  //     slopeRate2: 4,

  //   }
  // }
};


export const getTokenIdfromTokenDetails = (network: tNetworkTypes): string[] => {
  return Object.values(TOKEN_DETAILS).map((tokenDetail) => tokenDetail.tokenId[network || NETWORK_TYPES.TESTNET]);
}

export const getRequestHashfromTokenDetails = (): string[] => {

  return Object.values(TOKEN_DETAILS).map((tokenDetail) => tokenDetail.requestHash);
}